module.exports = __webpack_public_path__ + "4fccf0182ca6ed4aedd1199b2bcdc4e6.svg";


//////////////////
// WEBPACK FOOTER
// ./images/hourglass.svg
// module id = 949
// module chunks = 0